import { has, isObject, cloneDeep } from 'lodash';

const combineObjectValues = (array) => {
  const result = {};

  array.forEach((object) => {
    for (const key in object) {
      const value = object[key];
      if (has(result, key)) {
        // eslint-disable-next-line
        Array.isArray(value) ? result[key].push(...value) : result[key].push(value);
      } else {
        result[key] = Array.isArray(value) ? value : [value];
      }
    }
  });
  return result;
};

export function flattenAnswers(answers) {
  let clonedAnswers = cloneDeep(answers);

  for (const questionId in clonedAnswers) {
    const currentQuestionAnswers = clonedAnswers[questionId];
    const hasSubQuestions = Array.isArray(currentQuestionAnswers)
      && currentQuestionAnswers.some((answer) => isObject(answer));

    if (hasSubQuestions) {
      for (const answer of currentQuestionAnswers) {
        if (currentQuestionAnswers.length > 1) {
          clonedAnswers = { ...clonedAnswers, ...combineObjectValues(clonedAnswers[questionId]) };
        } else {
          clonedAnswers = { ...clonedAnswers, ...answer };
        }
      }
    }
  }

  return clonedAnswers;
}
